import { useLocalStorage } from '@vueuse/core'

export const token = useLocalStorage('lee-sd-token', '')
export const tokenName = useLocalStorage('lee-sd-token-name', '')
